<kui-modal #modal
    class="share-modal"
    size="md"
    [title]="title"
    [actions]="modalActions"
    (onClose)="detachModal()">
    <div class="p-4">

        <key-form-builder [form]="form"
            [values]="values"></key-form-builder>


        <div class=""
            *ngIf="link">

            <div class="">
                {{ "STATUS.DETAILS.SHARE.LINK_TEXT" | translate }}
                <a [href]="link"
                    target="_blank">{{link}}</a>
            </div>
            <div class="mt-2">
                <button kui-button
                    color="secondary"
                    (click)="doCopyLink()"
                    class="">{{ 'SHARED.COPY_LINK' | translate }}</button>
            </div>

        </div>

    </div>
</kui-modal>